var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProjectedit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      isolation: "isolate"
    },
    viewBox: "0 0 440 440",
    width: "440pt",
    height: "440pt",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clipPath_YTs6U1HXpsuRXFV3LOaCTen7XllNpfTI"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 440,
    height: 440
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clipPath_YTs6U1HXpsuRXFV3LOaCTen7XllNpfTI)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clipPath_EC6NlOgvIbPlA080UiHe1a9zCzIYIV0T"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 440,
    height: 440,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "rgb(255,255,255)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clipPath_EC6NlOgvIbPlA080UiHe1a9zCzIYIV0T)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: " M 220 340 C 220 284.808 264.808 240 320 240 C 375.192 240 420 284.808 420 340 C 420 395.192 375.192 440 320 440 C 264.808 440 220 395.192 220 340 Z  M 278.571 364.861 L 340.733 302.697 L 357.304 319.267 L 295.139 381.43 L 278.571 364.861 Z  M 364.408 312.165 L 366.775 309.798 C 368.988 307.585 370.207 304.643 370.207 301.513 C 370.207 298.383 368.988 295.442 366.775 293.229 C 364.562 291.016 361.619 289.794 358.489 289.794 C 355.359 289.794 352.417 291.014 350.203 293.227 L 347.836 295.594 L 364.408 312.165 Z  M 276.656 367.678 L 269.879 388.003 C 269.678 388.604 269.836 389.269 270.284 389.716 C 270.603 390.034 271.031 390.206 271.468 390.206 C 271.645 390.206 271.823 390.178 271.997 390.119 L 292.321 383.345 L 276.656 367.678 Z  M 343.102 300.33 L 345.471 297.961 L 362.041 314.531 L 359.672 316.9 L 343.102 300.33 Z ",
    fillRule: "evenodd",
    fill: "rgb(0,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 235.285 15 L 235.285 85 L 305.285 85 L 235.285 15 L 235.285 15 Z ",
    fill: "rgb(0,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 70.285 347.5 L 70.285 317.5 L 192.917 317.5 C 195.497 303.219 200.434 289.75 207.299 277.5 L 70.285 277.5 L 70.285 247.5 L 230.438 247.5 C 253.734 225.004 285.419 211.141 320.285 211.141 L 320.285 115 L 205.285 115 L 205.285 0 L 20.285 0 L 20.285 415 L 214.464 415 C 200.851 395.701 192.369 372.535 191.042 347.5 L 70.285 347.5 L 70.285 347.5 L 70.285 347.5 Z  M 70.285 177.5 L 270.285 177.5 L 270.285 207.5 L 70.285 207.5 L 70.285 177.5 L 70.285 177.5 L 70.285 177.5 Z ",
    fill: "rgb(0,0,0)"
  })))), /*#__PURE__*/React.createElement("g", null))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectedit);
export default __webpack_public_path__ + "static/media/projectedit.e1cff4eb0fa34228aa5b3e6784568f54.svg";
export { ForwardRef as ReactComponent };